import { QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { AnchorHTMLAttributes, FC } from "react";
import './Help.less';

export const XmHelp: FC<{ href?: string; tooltip?: string; size?: number | string; } & AnchorHTMLAttributes<HTMLAnchorElement>> = ({ href, tooltip, size, ...props }) => {
  const style = size ? { fontSize: typeof size === 'number' ? `${size}px` : size } : undefined;

  if (tooltip?.length && !href?.length) {
    return (
      <Tooltip title={tooltip}>
        <span className="xm-help" style={style} {...props}><QuestionCircleOutlined /></span>
      </Tooltip>
    );
  }

  if (tooltip?.length && href?.length) {
    return (
      <Tooltip title={tooltip}>
        <a className="xm-help xm-help__link" target="_blank" href={href} style={style} {...props}>
          <QuestionCircleOutlined />
        </a>
      </Tooltip>
    );
  }

  return (
    <a className="xm-help xm-help__link" target="_blank" href={href} style={style} {...props}>
      <QuestionCircleOutlined />
    </a>
  );
};